import { render, staticRenderFns } from "./ResourceActivityLogs.vue?vue&type=template&id=63d5a97b&"
import script from "./ResourceActivityLogs.vue?vue&type=script&lang=js&"
export * from "./ResourceActivityLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports